// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

export const S = {
  NotepadContainer: styled.div`
    position: fixed;
    right: 32px;
    transition: bottom 0.5s ease-in;
  `,
  NotepadButton: styled.button`
    position: relative;
    width: 80px;
    height: 80px;
    padding: 0;
    background-color: #666666;
    border-radius: 100%;
    cursor: pointer;
  `,
  NotepadIcon: styled.img`
    width: 30px;
    height: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
  NotepadTextBoxContainer: styled.div`
    position: absolute;
    bottom: 100px;
    right: 0px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    padding: 22px;
  `,
  NotepadTextBoxTitle: styled.div`
    font-family: 18px Noto Sans TC;
    line-height: 26px;
    color: #666666;
    margin-bottom: 16px;
  `,
  NotepadTextBox: styled.textarea`
    font-family: 16px Noto Sans TC;
    line-height: 24px;
    resize: none;
    border: 0px;
    width: 320px;
    min-height: 200px;

    &::placeholder {
      color: #C9C9C9;
    }

    &:focus {
      outline: none;
      border: 0px;
    }
  `
};
